type ListCreationError = {
  emptyName: boolean;
  duplicateName: boolean;
  invalidDateRange: boolean;
  startDateOutOfBound: boolean;
  listNotFound: boolean;
};

const listCreationError: ListCreationError = {
  emptyName: false,
  duplicateName: false,
  invalidDateRange: false,
  startDateOutOfBound: false,
  listNotFound: false,
};

export type { ListCreationError };

export { listCreationError };
